module.exports = __webpack_public_path__ + "static/media/banner-solicitacao-abastecimento.9e36e9c2.png";